import Controller from '@ember/controller';

export default class LocationOverviewManageAuditLogController extends Controller {
  // TODO:
}
